"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TableRow_1 = require("./TableRow");
exports.default = TableRow_1.default;
//# sourceMappingURL=index.js.map